import React from 'react'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
export default function MemberBookingRecovery({ recovery }) {
  const { t } = useOptionalPrivanaI18n()
  if (!recovery.pending) return null
  return <div className="mp-warning" role="status">
    <p>{t(`facilityBooking.${recovery.status === 'needs_help' ? 'recoveryHelp' : recovery.status ? 'recoveryPending' : 'recoveryExplain'}`)}</p>
    <button className="mp-btn mp-btn--secondary" type="button" disabled={recovery.checking} onClick={recovery.reconcile}>{t(`facilityBooking.${recovery.checking ? 'recoveryChecking' : 'recoveryCheck'}`)}</button>
  </div>
}
